import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./BadgeTC.css";

const BadgeTC = () => {
  const User = useSelector((state) => state.currentUserReducer);
  return (
    <article className="TC-details-container">
      <h1>Criteria for getting a Badge</h1>
      <h2 className="badge-info">For "EXPLORER" Badge : </h2>
      <p>
        You will qualify for <strong>"EXPLORER"</strong> Badge if you get more
        than 5 Upvotes on your question
      </p>
      <h2 className="badge-info">For "AMATEUR" Badge : </h2>
      <p>
        You will qualify for <strong>"AMATEUR"</strong> Badge if you give more
        than 5 answers
      </p>
      <p className="warning-text">
        P.S. This conditions will be applicable on your activity since you
        joined Stack Overflow Community.
      </p>
      <p>
        <Link to={`/Users/${User?.result?._id}`}>
          <strong>Click here</strong>
        </Link>{" "}
        to return to your Profile.
      </p>
    </article>
  );
};

export default BadgeTC;
